import { render, staticRenderFns } from "./PazarPlus.vue?vue&type=template&id=0d605362"
import script from "./PazarPlus.vue?vue&type=script&lang=js"
export * from "./PazarPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports